import {
    SET_TEMPUSERDATA,
  } from '../constants/ActionTypes'
  
  const initialState = [
    {
      tempUserData: []
    }
  ]
  
  export default function tempUserData(state = initialState, action: any) {
    switch (action.type) {
      case SET_TEMPUSERDATA:
        return [
          {
            tempUserData: action.tempUserData,
          }
        ]
      default:
        return state
    }
  }
  